import styled from 'styled-components';
import {motion} from 'framer-motion';
import {alignCenter, dFlexCenter, dFlexColumn} from '../../../../globalVariables/GlobalFlex';
import {lightIsland} from '../../eTicketTheme.css';
import {qrShakeOnScan} from './QrScanShake.css';
export const overlay = styled(motion.div)`
    ${lightIsland}
    position: fixed;
    inset: 0;
    z-index: 50;
    background: var(--color-bg-base);
    ${dFlexCenter};
    cursor: zoom-out;
`;

export const inner = styled(motion.div)`
    ${dFlexColumn}
    ${alignCenter}
    gap: var(--space-xl);
`;

export const qrWrap = styled.div`
    position: relative;
`;

export const qrCanvas = styled.div<{$isScanning?: boolean}>`
    canvas {
        width: min(74vw, 62vh) !important;
        height: min(74vw, 62vh) !important;
        max-width: 400px !important;
        max-height: 400px !important;
        display: block;

        ${p => p.$isScanning && qrShakeOnScan}    }
`;

export const ticketNo = styled.div`
    font-size: var(--font-size-body-small);
    color: var(--color-text-subtle);
    text-align: center;
`;
